'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NS = ['http://www.w3.org/1999/xhtml', 'http://www.w3.org/2000/svg'];
var elements = {};

exports.default = function (name) {
  if (name in elements) return elements[name];
  var domElem = window.HTMLUnknownElement;

  for (var i = 0; i < NS.length; i += 1) {
    domElem = document.createElementNS(NS[i], name);

    if (!(domElem instanceof window.HTMLUnknownElement)) {
      elements[name] = domElem;
      return domElem;
    }
  }

  return domElem;
};